import React, { useEffect, useState, } from "react";

import apiService from "../services/apiService";

import ExamPills from "../component/ExamPills";

import BC from "../component/Breadcrumb";

import Bdg from "../component/Badge";

import I from "../component/Icon";



const GET_STUDENT_BY_ID_API =

  `Student/getStudentById`;



const parseMaybeJson = (value) => {

  if (typeof value !== "string") {

    return value;

  }



  try {

    return JSON.parse(value);

  } catch {

    return value;

  }

};




// View-only helpers: read the same IDs and detail rows saved by StudentForm.
const val = (obj, ...keys) => {
  for (const key of keys) if (obj?.[key] !== undefined && obj?.[key] !== null && obj?.[key] !== "") return obj[key];
  return null;
};
const arr = (source) => {
  const data = parseMaybeJson(source);
  if (Array.isArray(data)) return data;
  if (!data || typeof data !== "object") return [];
  for (const key of ["output", "Output", "result", "Result", "data", "Data", "items", "Items", "rows", "Rows"]) {
    const nested = arr(data[key]);
    if (nested.length) return nested;
  }
  return [];
};
const rupees = (v) => `₹${Number(v || 0).toLocaleString("en-IN")}`;
const display = (v) => v === null || v === undefined || v === "" ? "—" : String(v);
const yesNo = (v) => v === true || v === 1 || v === "1" || String(v).toLowerCase() === "true";
const detailRows = (obj) => arr(val(obj, "studentDetails", "StudentDetails", "stdDetlst", "StdDetlst"));
const infoCard = { marginBottom: 14 };
const lookupLabel = (rows, id, keys) => {
  if (id === null || id === undefined || id === "" || Number(id) === 0) return "—";
  const found = rows.find(row => String(val(row, "id", "Id", ...keys)) === String(id));
  return found ? display(val(found, "name", "Name", "stdName", "StdName", "stdStatusName", "StdStatusName", "examName", "ExamName", "schoolName", "SchoolName", "districtName", "DistrictName", "talukaName", "TalukaName")) : `#${id}`;
};
const DetailCard = ({ title, fields }) => (
  <div className="card cp" style={infoCard}>
    <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 14 }}>{title}</div>
    <div className="fgrid" style={{ gap: 9 }}>
      {fields.map(([label, value]) => (
        <div className="vf" key={label}>
          <div className="vfl">{label}</div>
          <div className="vfv" style={{ fontSize: 12.5 }}>{display(value)}</div>
        </div>
      ))}
    </div>
  </div>
);

export default function StudentView({

  student,

  school,

  onBack,

  onEdit,

}) {

  const [studentDetail, setStudentDetail] =

    useState(student);



  const [loading, setLoading] =

    useState(false);



  const [error, setError] =

    useState("");

  const [lookups, setLookups] = useState({ standards: [], mediums: [], exams: [], schools: [], districts: [], talukas: [], books: [] });
  useEffect(() => {
    let active = true;
    const endpoints = {
      standards: ["get", "StandardMaster/getAllStandardMasters"],
      mediums: ["get", "StdStatus/getAllStdStatus"],
      exams: ["get", "Exam/getAllExam"],
      schools: ["get", "School/getAllSchool"],
      districts: ["get", "DistrictMaster/getAllDistrictMasters?includeInActive=true"],
      talukas: ["get", "TalukaMaster/getAllTalukaMasters?includeInActive=true"],
      books: ["post", "BookMaster/getPaginatedBookMasters"]
    };
    Promise.allSettled(Object.entries(endpoints).map(async ([key, [method, url]]) => {
      const response = method === "post"
        ? await apiService.post(url, { Page: 1, PageSize: 1000, SearchTerm: "", SortDirection: "DESC", SortField: "Id", IncludeInActive: true })
        : await apiService.get(url);
      return [key, arr(response?.data)];
    })).then(results => {
      if (!active) return;
      setLookups(previous => {
        const updated = { ...previous };
        results.forEach(item => { if (item.status === "fulfilled") updated[item.value[0]] = item.value[1]; });
        return updated;
      });
    });
    return () => { active = false; };
  }, []);




  useEffect(() => {

    const fetchStudentById =

      async () => {

        const studentId =

          student?.id ??

          student?.Id;



        if (!studentId) {

          setError(

            "StudentId not found"

          );

          return;

        }



        try {

          setLoading(true);

          setError("");



          const response =

            await apiService.get(

              `${GET_STUDENT_BY_ID_API}/${encodeURIComponent(

                studentId

              )}`

            );



          const data =

            parseMaybeJson(

              response.data

            );



          console.log(

            "Get Student By Id Response:",

            data

          );



          if (

            data?.isSuccess === false ||

            data?.IsSuccess === false

          ) {

            throw new Error(

              data?.failureReason ??

              data?.FailureReason ??

              data?.message ??

              data?.Message ??

              "Unable to load student details"

            );

          }



          let result =

            data?.output ??

            data?.Output ??

            data?.data ??

            data?.Data ??

            data;



          result =

            parseMaybeJson(result);



          if (!result) {

            throw new Error(

              "Student data not found"

            );

          }



          /*

            GetById API PascalCase किंवा camelCase

            दोन्ही return करू शकते.

          */



          const firstName =

            result.firstName ??

            result.FirstName ??

            "";



          const middleName =

            result.middleName ??

            result.MiddleName ??

            "";



          const lastName =

            result.lastName ??

            result.LastName ??

            "";



          const fullName =

            result.fullName ??

            result.FullName ??

            [

              firstName,

              middleName,

              lastName,

            ]

              .filter(Boolean)

              .join(" ")

              .replace(

                /\s+/g,

                " "

              )

              .trim();



        let studentDetails =

  result.studentDetails ??

  result.StudentDetails ??

  result.stdDetlst ??

  result.StdDetlst ??

  [];



          studentDetails =

            parseMaybeJson(

              studentDetails

            );



          if (

            !Array.isArray(

              studentDetails

            )

          ) {

            studentDetails = [];

          }



          const hasPendingFees =

            studentDetails.some((detail) => {

              const pendingFees = Number(

                detail?.pendingFees ??

                detail?.PendingFees ??

                0

              );



              return pendingFees > 0;

            });



          const isPaid =

            studentDetails.length > 0 &&

            !hasPendingFees;

          const mappedDetail = {

            ...student,

            ...result,



            id:

              result.id ??

              result.Id ??

              studentId,



            name:

              fullName ||

              student?.name ||

              "Student",



            dob:

              result.dob ??

              result.DOB ??

              student?.dob ??

              "",



            phone:

              result.phone ??

              result.Phone ??

              result.fatherPhone ??

              result.FatherPhone ??

              student?.phone ??

              "",



            email:

              result.email ??

              result.Email ??

              result.fatherEmail ??

              result.FatherEmail ??

              student?.email ??

              "",



            address:

              result.address ??

              result.Address ??

              student?.address ??

              "",



            pincode:

              result.pincode ??

              result.Pincode ??

              student?.pincode ??

              "",



            schoolId:

              result.schoolId ??

              result.SchoolId ??

              student?.schoolId,



            stdId:

              result.stdId ??

              result.StdId ??

              student?.stdId,



            class:

              result.stdName ??

              result.StdName ??

              result.className ??

              result.ClassName ??

              student?.class ??

              "",



            status:

              (

                result.isActive ??

                result.IsActive

              ) === false ||

                (

                  result.isActive ??

                  result.IsActive

                ) === 0

                ? "dropped"

                : "active",



            studentDetails,

            isPaid,



            exams:

              result.exams ??

              result.Exams ??

              student?.exams ??

              [],



            examScores:

              result.examScores ??

              result.ExamScores ??

              student?.examScores ??

              [],

          };





          setStudentDetail(

            mappedDetail

          );

        } catch (err) {

          console.error(

            "Get Student By Id Error:",

            err

          );



          const apiError =

            err?.response?.data;



          setError(

            apiError?.failureReason ??

            apiError?.FailureReason ??

            apiError?.message ??

            apiError?.Message ??

            err?.message ??

            "Unable to load student"

          );

        } finally {

          setLoading(false);

        }

      };



    fetchStudentById();

  }, [student]);



  const s =

    studentDetail ||

    student;



  if (loading) {

    return (

      <>

        <BC

          items={[

            "Students",

            student?.name ||

            "Student",

          ]}

          onBack={onBack}

        />



        <div

          className="card cp"

          style={{

            textAlign: "center",

            padding: 30,

          }}

        >

          Loading student details...

        </div>

      </>

    );

  }



  if (error && !s) {

    return (

      <>

        <BC

          items={[

            "Students",

            "Student",

          ]}

          onBack={onBack}

        />



        <div

          className="card cp"

          style={{

            color: "#dc2626",

            textAlign: "center",

          }}

        >

          {error}

        </div>

      </>

    );

  }



  const studentName =

    s?.name || "Student";



  const className =

    s?.class || "—";



  const schoolName =
    s?.schoolName ??
    s?.SchoolName ??
    school?.name ??
    lookupLabel(lookups.schools, val(s, "schoolId", "SchoolId"), ["schoolId", "SchoolId"]);

  const studentRows = detailRows(s);
  const activeRows = studentRows.filter(d => val(d, "isActive", "IsActive") !== false && val(d, "isActive", "IsActive") !== 0);
  const groupedExams = [...new Map(activeRows.filter(d => Number(val(d, "examId", "ExamId")) > 0).map(d => [String(val(d, "examId", "ExamId")), d])).values()];
  const classDisplay = lookupLabel(lookups.standards, val(s, "stdId", "StdId"), ["stdId", "StdId"]);
  const mediumDisplay = lookupLabel(lookups.mediums, val(s, "stdStatusId", "StdStatusId"), ["stdStatusId", "StdStatusId"]);
  const chosenBooks = lookups.books.flatMap(master => {
    const nested = arr(val(master, "teaBooAssDetlst", "TeaBooAssDetlst", "bookDetails", "BookDetails"));
    return nested.map(book => ({ ...book, master }));
  });
  const bookName = id => {
    const b = chosenBooks.find(b => Number(val(b, "id", "Id", "bookDetailId", "BookDetailId")) === Number(id));
    if (!b) return `Book Detail #${id}`;
    const master = b.master;
    return display(val(b, "bookName", "BookName", "name", "Name", "title", "Title") ?? val(master, "bookName", "BookName", "name", "Name", "title", "Title") ?? `Book Detail #${id}`);
  };



  return (

    <>

      <BC

        items={[

          "Students",

          studentName,

        ]}

        onBack={onBack}

      />



      {error && (

        <div

          style={{

            marginBottom: 12,

            padding: 10,

            borderRadius: 6,

            background: "#fef2f2",

            color: "#dc2626",

            fontSize: 12,

          }}

        >

          {error}

        </div>

      )}



      <div

        style={{

          display: "flex",

          gap: 14,

          flexWrap: "wrap",

          alignItems:

            "flex-start",

        }}

      >

        {/* LEFT PROFILE */}



        <div

          style={{

            flex:

              "0 0 240px",

          }}

        >

          <div

            className="card cp"

            style={{

              textAlign:

                "center",

            }}

          >

            <div

              className="av"

              style={{

                width: 56,

                height: 56,

                margin:

                  "0 auto 11px",

                fontSize: 18,



                background:

                  `hsl(${Number(

                    s?.id || 1

                  ) *

                  55 +

                  190

                  },58%,52%)`,

              }}

            >

              {studentName?.[0] ||

                "S"}

            </div>



            <div

              style={{

                fontWeight: 700,

                fontSize: 14,

              }}

            >

              {studentName}

            </div>



            <div

              style={{

                fontSize: 12,

                color:

                  "var(--t3)",

                marginTop: 2,

              }}

            >

              {schoolName}

            </div>



            <div

              style={{

                display: "flex",

                gap: 6,

                justifyContent:

                  "center",

                marginTop: 9,

                flexWrap: "wrap",

              }}

            >

              <Bdg

                type="blue"

                label={`Class ${className}`}

              />

            </div>



            <div

              style={{

                marginTop: 9,

              }}

            >

              <ExamPills

                exams={

                  s?.exams || []

                }

              />

            </div>



            <button

              type="button"

              className="btn btn-p"

              style={{

                width: "100%",

                marginTop: 14,

                justifyContent:

                  "center",

              }}

              onClick={() =>

                onEdit?.(s)

              }

            >

              <I

                n="edit"

                s={12}

                c="#fff"

              />



              Edit Profile

            </button>

          </div>

        </div>



        {/* RIGHT */}



        <div

          style={{

            flex: 1,

          }}

        >

          <div

            className="card cp"

            style={{

              marginBottom: 14,

            }}

          >

            <div

              style={{

                fontWeight: 700,

                fontSize: 13,

                marginBottom: 14,

              }}

            >

              Student Details

            </div>



            <div

              className="fgrid"

              style={{

                gap: 9,

              }}

            >

              {[

                [

                  "Class",

                  `Class ${className}`,

                ],



                [

                  "Date of Birth",

                  s?.dob || "—",

                ],



                [

                  "Phone",

                  s?.phone || "—",

                ],



                [

                  "Email",

                  s?.email || "—",

                ],



                [

                  "Address",

                  s?.address ||

                  "—",

                ],



                [

                  "Pincode",

                  s?.pincode ||

                  "—",

                ],



                [

                  "School",

                  schoolName,

                ],



                [

                  "Status",

                  s?.isPaid === true

                    ? "Paid"

                    : "Pending",

                ],

              ].map(

                ([key, value]) => (

                  <div

                    key={key}

                    className="vf"

                  >

                    <div className="vfl">

                      {key}

                    </div>



                    <div

                      className="vfv"

                      style={{

                        fontSize:

                          12.5,

                      }}

                    >

                      {value}

                    </div>

                  </div>

                )

              )}

            </div>

          </div>



                      <DetailCard title="Personal & Parent Details" fields={[
              ["Document No", val(s, "documentNo", "DocumentNo")],
              ["First Name", val(s, "firstName", "FirstName")],
              ["Middle Name", val(s, "middleName", "MiddleName")],
              ["Last Name", val(s, "lastName", "LastName")],
              ["Gender", ({0:"Male",1:"Female",2:"Other"})[val(s, "gender", "Gender")] ?? val(s,"gender","Gender")],
              ["Father / Parent Name", val(s, "fatherName", "FatherName")],
              ["Father / Parent Phone", val(s, "fatherPhone", "FatherPhone")],
              ["Father / Parent Email", val(s, "fatherEmail", "FatherEmail")],
            ]} />

            <DetailCard title="Academic & Location Details" fields={[
              ["Class / Standard", classDisplay !== "—" ? classDisplay : className],
              ["Medium", mediumDisplay],
              ["State", val(s,"stateName","StateName") ?? (Number(val(s,"stateId","StateId")) === 1 ? "Maharashtra" : val(s,"stateId","StateId"))],
              ["District", lookupLabel(lookups.districts, val(s,"districtId","DistrictId"), ["districtId","DistrictId"])],
              ["Taluka", lookupLabel(lookups.talukas, val(s,"talukaId","TalukaId"), ["talukaId","TalukaId"])],
              ["School", schoolName],
              ["Student Status", (val(s,"isActive","IsActive") === false || val(s,"isActive","IsActive") === 0) ? "Inactive" : "Active"],
            ]} />

            <div className="card cp" style={{ marginBottom: 14 }}>
              <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 14 }}>Selected Exams & Books</div>
              {groupedExams.length ? groupedExams.map((row, index) => {
                const examId = val(row,"examId","ExamId");
                const rows = activeRows.filter(d => String(val(d,"examId","ExamId")) === String(examId));
                const ids = [...new Set(rows.map(d => Number(val(d,"bookDetailId","BookDetailId"))).filter(id => id > 0))];
                return <div key={`${examId}-${index}`} style={{ marginBottom: 12, paddingBottom: 10, borderBottom: "1px solid var(--bd, #e5e7eb)" }}>
                  <div style={{ fontWeight: 700, fontSize: 12.5 }}>{lookupLabel(lookups.exams, examId, ["examId","ExamId"])}</div>
                  <div style={{ marginTop: 5, fontSize: 12, color: "var(--t3)" }}>
                    {ids.length ? ids.map(id => bookName(id)).join(", ") : "No book selected"}
                  </div>
                </div>;
              }) : <div style={{ fontSize: 12, color: "var(--t3)" }}>No exam details available</div>}
            </div>

            <DetailCard title="Fees & Payment Details" fields={[
              ["Exam Total Fees", rupees(activeRows.reduce((sum,d) => sum + Number(val(d,"examTotalFees","ExamTotalFees") || 0),0))],
              ["Fees Paid", rupees(activeRows.reduce((sum,d) => sum + Number(val(d,"feesPaid","FeesPaid") || 0),0))],
              ["Pending Fees", rupees(activeRows.reduce((sum,d) => sum + Number(val(d,"pendingFees","PendingFees") || 0),0))],
              ["Courier Charges", rupees(activeRows.reduce((sum,d) => sum + Number(val(d,"courierCharges","CourierCharges") || 0),0))],
              ["Payment Status", activeRows.length && activeRows.every(d => yesNo(val(d,"isPaid","IsPaid")) || (Number(val(d,"pendingFees","PendingFees") || 0) === 0 && Number(val(d,"examTotalFees","ExamTotalFees") || 0) > 0)) ? "Paid" : "Pending"],
            ]} />

            <div className="card cp" style={{ marginBottom: 14 }}>
              <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 14 }}>Book Dispatch & Courier Details</div>
              {activeRows.length ? activeRows.map((d,index) => {
                const id = Number(val(d,"bookDetailId","BookDetailId") || 0);
                return <div className="fgrid" key={val(d,"id","Id") ?? index} style={{ gap: 9, marginBottom: 12 }}>
                  {[["Exam", lookupLabel(lookups.exams, val(d,"examId","ExamId"), ["examId","ExamId"])],
                    ["Book", id > 0 ? bookName(id) : "No book selected"],
                    ["Post Tracking No", val(d,"postTrackNo","PostTrackNo")],
                    ["Book Sent", yesNo(val(d,"isBookSend","IsBookSend")) ? "Yes" : "No"]].map(([label,value]) =>
                    <div className="vf" key={label}><div className="vfl">{label}</div><div className="vfv" style={{ fontSize: 12.5 }}>{display(value)}</div></div>
                  )}
                </div>;
              }) : <div style={{ fontSize: 12, color: "var(--t3)" }}>No dispatch details available</div>}
            </div>

{/* EXAM HISTORY */}



          {/* <div className="card cp">

            <div

              style={{

                fontWeight: 700,

                fontSize: 13,

                marginBottom: 14,

              }}

            >

              Exam History

            </div>



            {s?.examScores &&

              s.examScores.length >

              0 ? (

              <div className="tw">

                <table>

                  <thead>

                    <tr>

                      <th>Exam</th>

                      <th>Score</th>

                      <th>Total</th>

                      <th>

                        Percentage

                      </th>

                      <th>Result</th>

                    </tr>

                  </thead>



                  <tbody>

                    {s.examScores.map(

                      (

                        exam,

                        index

                      ) => {

                        const pct =

                          Math.round(

                            (exam.score /

                              exam.total) *

                            100

                          );



                        return (

                          <tr

                            key={

                              index

                            }

                          >

                            <td className="tdb">

                              {

                                exam.exam

                              }

                            </td>



                            <td

                              style={{

                                fontWeight:

                                  700,



                                color:

                                  "var(--p)",

                              }}

                            >

                              {

                                exam.score

                              }

                            </td>



                            <td>

                              {

                                exam.total

                              }

                            </td>



                            <td>

                              <div

                                style={{

                                  display:

                                    "flex",



                                  alignItems:

                                    "center",



                                  gap: 7,

                                }}

                              >

                                <div

                                  className="pw"

                                  style={{

                                    width:

                                      55,



                                    height:

                                      5,

                                  }}

                                >

                                  <div

                                    className={`pf ${pct >=

                                      75

                                      ? "pg"

                                      : "pb"

                                      }`}

                                    style={{

                                      width:

                                        `${pct}%`,

                                    }}

                                  />

                                </div>



                                <span

                                  style={{

                                    fontSize:

                                      11.5,



                                    fontWeight:

                                      700,

                                  }}

                                >

                                  {pct}%

                                </span>

                              </div>

                            </td>



                            <td>

                              <Bdg

                                type={

                                  pct >=

                                    75

                                    ? "green"

                                    : pct >=

                                      40

                                      ? "yellow"

                                      : "red"

                                }

                                label={

                                  pct >=

                                    40

                                    ? "Pass"

                                    : "Fail"

                                }

                              />

                            </td>

                          </tr>

                        );

                      }

                    )}

                  </tbody>

                </table>

              </div>

            ) : (

              <div

                style={{

                  textAlign:

                    "center",



                  padding:

                    "18px",



                  color:

                    "var(--t3)",



                  fontSize: 12,



                  background:

                    "var(--bg)",



                  borderRadius:

                    "var(--r2)",

                }}

              >

                No exam scores

                recorded yet

              </div>

            )}

          </div> */}

        </div>

      </div>

    </>

  );

}